interface SubSectionProps {
  title: string;
  icon: React.ElementType;
  children: React.ReactNode;
  isCollapsed: boolean;
}

export function SubSection({ title, children, isCollapsed }: SubSectionProps) {
  return (
    <div className="space-y-1">
      {!isCollapsed && (
        <h3 className="px-3 text-xs font-semibold text-muted-foreground uppercase tracking-wider mb-3">
          {title}
        </h3>
      )}
      <div className="space-y-1">{children}</div>
    </div>
  );
}
